const globalKeys = {
  filters: ["filters"] as const,
  scopedViewFilters: () => [...globalKeys.filters, "scopedViews"] as const,
};

export default globalKeys;
